export enum AvailableUnits {
  METRIC = 'metric',
  IMPERIAL = 'imperial'
}

export const getUnitsArray = () => {
  const units: string[] = []

  for (const l in AvailableUnits) {
    units.push((AvailableUnits as any)[l])
  }

  return units
}

export const getInitialUnits = (): AvailableUnits => {
  const initialUnits =
    (localStorage.getItem('units') as AvailableUnits) || 'metric'

  return initialUnits
}
